import { render, staticRenderFns } from "./CustomerTreatmentColumn.vue?vue&type=template&id=332a2334&scoped=true&"
import script from "./CustomerTreatmentColumn.vue?vue&type=script&lang=js&"
export * from "./CustomerTreatmentColumn.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTreatmentColumn.vue?vue&type=style&index=0&id=332a2334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a2334",
  null
  
)

export default component.exports